import { CSSProperties } from 'react';
import { Handle, HandleProps } from 'reactflow';

type CustomHandleProps = HandleProps & { style: CSSProperties };

const CustomHandle = (props: CustomHandleProps) => (
  <Handle
    {...props}
    style={{
      ...props.style,
      width: 8,
      height: 8,
      background: 'white',
      border: '2px solid black',
    }}
  />
);

export default CustomHandle;
